import classNames from 'classnames';
import Icon from '../../components/icons/Icon';
import React from 'react';
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../mobile/structural/sheet/sheetTypes';
import MobileReactionsSheet from './popup/MobileReactionsSheet';

type Props = { elementId: string; gridSize: number };

const MobileElementReactionAddButton = (props: Props) => {
    const { elementId } = props;

    const sheetProps = useSheet(SheetId.ElementReactionTool, elementId);
    const { isSheetOpen, dispatchOpenSheet, dispatchCloseSheet } = sheetProps;

    return (
        <div className="sheet-trigger">
            <div className={classNames('add-icon', { active: isSheetOpen })} onClick={dispatchOpenSheet}>
                <Icon name="reaction-add" />
            </div>
            <MobileReactionsSheet
                {...props}
                sheetProps={sheetProps}
                closePopup={dispatchCloseSheet}
                elementIds={[elementId]}
            />
        </div>
    );
};

export default MobileElementReactionAddButton;
